import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { FundProjectionScreenOutlined, FundViewOutlined, TableOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/report',
    name: 'report',
    // redirect: '/report/view',
    component: Layout,
    meta: {
      title: 'Report',
      icon: renderIcon(FundProjectionScreenOutlined),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: [
        'report_equipment_read',
        'report_pco-recommendation_read',
        'report_po-tracker_read',
        // 'report_view_read',
        'report_pivot-table_read',
      ],
      sort: 7,
    },
    children: [
      // {
      //   path: 'view',
      //   name: 'report_view',
      //   meta: {
      //     title: 'View',
      //     icon: renderIcon(FundViewOutlined),
      //     hidden: true,
      //     //配置该路由需要哪些权限可访问 这里是针对单个路由
      //     permissions: ['report_view_read'],
      //   },
      //   component: () => import('@/views/report/view/index.vue'),
      // },
      {
        path: 'pivot-table',
        name: 'report_pivot-table',
        meta: {
          title: 'Pivot Table',
          icon: renderIcon(TableOutlined),
          permissions: ['report_pivot-table_read'],
        },
        component: () => import('@/views/report/pivot-table/index.vue'),
      },
      {
        path: '/equipment-report',
        name: 'report_equipment',
        meta: {
          title: 'Equipment',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['report_equipment_read'],
          //spname:'financialReportTaxesIncluded',
          spname: 'rpt_customized_equipment',
        },
        component: () => import('@/views/report/view/equipment.vue'),
      },
      {
        path: '/pco-recommendation-report',
        name: 'report_pco-recommendation',
        meta: {
          title: 'PCO Recomm.',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['report_pco-recommendation_read'],
          spname: 'rpt_customized_pco_recommendation_to_purchase',
        },
        component: () => import('@/views/report/view/pcorecommendation.vue'),
      },
      {
        path: '/po-tracker-report',
        name: 'report_po-tracker',
        meta: {
          title: 'PO Tracker',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['report_po-tracker_read'],
          spname: 'rpt_po_tracker',
        },
        component: () => import('@/views/report/view/rptPrPo.vue'),
      },
      // {
      //   path: '/equipment_changelog',
      //   name: 'equipment_changelog',
      //   meta: {
      //     title: 'Equipment Changelog - NSHBCC',
      //     icon: renderIcon(FundViewOutlined),
      //     //配置该路由需要哪些权限可访问 这里是针对单个路由
      //     permissions: ['report_view_read'],
      //     spname: 'rpt_eqipment_chg_log_NSHBCCC',
      //   },
      //   component: () => import('@/views/report/view/equipment-changelog.vue'),
      // },
      // {
      //   path: '/kcc_equipment_report',
      //   name: 'kcc_equipment_report',
      //   meta: {
      //     title: 'BCC RIH Kamloops Cancer Centre IH Equip List',
      //     icon: renderIcon(FundViewOutlined),
      //     //配置该路由需要哪些权限可访问 这里是针对单个路由
      //     permissions: ['report_view_read'],
      //     spname: 'rpt_equipment_kcc',
      //   },
      //   component: () => import('@/views/report/view/kcc-equipment-report.vue'),
      // },
    ],
  },
];

export default routes;
